import FILTERS from "../enums/RouteDetailFilters";

export const PERMISSION_DENIED = "Insufficient Permissions";

export const SHOW_ME_ALL = "Show Me All:";

export const FILTER_TITLES = {
  [FILTERS.EXCEPTIONS]: "Exceptions",
  [FILTERS.PREMIUMS]: "Premiums",
  [FILTERS.OPPORTUNITY]: "Opportunity",
  [FILTERS.CONSOLIDATED]: "Consolidated",
  [FILTERS.MATCHING_POSTCODES]: "Matching Postcodes",
  [FILTERS.NON_COMPATIBLES]: "Non-Compatibles",
  [FILTERS.NON_LOADED_PARCELS]: "Non-Loaded Parcels",
  [FILTERS.NON_CADS]: "Non-CADs",
  [FILTERS.SHOW_IN_ROUTE]: "Show In Route",
};

export const VEHICLE = "Vehicle";
export const STOP = "Stop";
export const PRIORITY = "Priority";
export const TYPE = "Type";
export const ADDRESS = "Address";
export const POSTCODE = "Postcode";
export const RAG = "RAG";
export const PARCELS = "Parcels";
export const COLLECTIONS = "Collections";
export const CAD = "CAD";
export const CADS = "CADS";
export const SMALLS = "Smalls";
export const LOADED = "Loaded";
export const STOP_TIME = "Stop Time";
export const ETA = "ETA";
export const OT = "OT";
export const EXCEPTION = "Exception";
export const WINDOW = "Window";
export const NON_COMPATIBLES_SHORT = "N/C";
export const WEIGHT = "Weight";
export const CHUTE = "Chute";
export const REQUEST = "Request";
export const SERVICE = "Service";
export const DUTY = "Duty";
export const RANGE = "Range";
export const LEGAL_DUTY = "Legal Duty";
export const MIXED = "Mixed";
export const LUNCH_BREAK = "Lunch Break";
export const SATURDAY_SERVICE_SHORT = "Sat";
export const SUNDAY_SERVICE_SHORT = "Sun";
export const RETURN_TO_DEPOT = "Return to depot";
export const KG = "Kg";
export const SELECT_BY = "SELECT BY:";
export const ADD_NEW_CRITERIA = "Add New Criteria";
export const BACK = "Back";
export const SELECT_MULTIPLE = "Select Multiple";
export const MOVE_TO = "Move To";
export const MOVE = "Move";
export const MOVED = "Moved";
export const REMOVE = "Remove";
export const SUGGESTED_ROUTES = "Suggested Routes";
export const ALL_ROUTES = "All Routes";
export const FROM = "From";
export const TO = "To";
export const PLACE_BEFORE_STOP = "Place before stop";
export const SELECT_ALL_STOPS = "Select All Stops";
export const CLEAR_SELECTED = "Clear Selected";
export const MERGE = "Merge";
export const SCHEDULE = "Schedule";
export const OPTIMISE = "Optimise";
export const TRANSFER_AND_SCHEDULE = "Transfer & Schedule";
export const TRANSFER_AND_OPTIMISE = "Transfer & Optimise";
export const TRANSFER_ONLY = "Transfer Only";
export const MOVE_AND_SCHEDULE = "Move & Schedule";
export const MOVE_AND_OPTIMISE = "Move & Optimise";
export const MOVE_ONLY = "Move Only";
export const REMOVE_OPTIONS = "Remove Options";
export const AFFECTED_STOPS = "Affected Stops";
export const SAVE = "Save";
export const CONFIRM = "Confirm";
export const STOPS_SELECTED = "Stops Selected";
export const X = "x";
export const PRIO = "Prio";
export const PARCEL_NUMBER = "Parcel Number";
export const TYPE_OF_COLLECTION = "Type of Collection";
export const KING = "King";
export const LOAD = "Load";
export const REQ = "Req";
export const BULK = "Bulk";
export const SPLIT = "Split";
export const TRANSFER = "Transfer";
export const TRANSFERRED = "Transferred";
export const READY = "Ready";
export const OPEN = "Open";
export const DISMISS = "Dismiss";
export const DRIVER_REQUEST = "Driver Request";
export const YES = "Yes";
export const NO = "No";
export const PROCEED = "Proceed";
export const CANCEL = "Cancel";
export const FILTER = "FILTER";
export const HIGH_VALUE_PARCEL = "High Value Parcel";
export const TOTE_PARCEL = "Tote Parcel";

export const BEFORE_SCHEDULE = "Before Schedule";
export const AFTER_SCHEDULE = "After Schedule";
export const MAKE_MORE_CHANGES = "Make More Changes";
export const RESET_ALL_CHANGES = "Reset All Changes";
export const SAVE_AND_EXIT = "Save & Exit";
export const INVALID_STOP_TIME = "Invalid Stop Time";
export const INVALID_POSTCODE = "Invalid Postcode";
export const INVALID_PRIORITY = "Invalid Priority";
export const INVALID_PARCEL_AGE = "Invalid Parcel Age";

export const SCHEDULE_RESULTS_FIELDS = {
  MILEAGE: "mileage",
  OPPORTUNITY: "opportunity",
  EXCEPTIONS: "exceptions",
  DEPOT_TO_1ST_STOP: "depot to 1st stop",
  LAST_STOP_END_TIME: "last stop end time",
  LAST_STOP_TO_DEPOT: "last stop to depot",
  RETURN_TO_DEPOT: "return to depot",
};

export const RETRY = "Retry";
export const FAILED_REASON = "Failed Due To";
export const RETRY_OR_RESET = "Click Retry To Try Again Or Reset All changes.";
export const WORKING = "Working";

export const ARE_YOU_SURE_TO_RESET =
  "Are You Sure You Want To Reset All Of Your Changes?";
export const ARE_YOU_SURE_TO_CONTINUE = "Are you sure you want to continue?";
export const WILL_APPLY_TO_ALL_ROUTES = `${ARE_YOU_SURE_TO_CONTINUE}\n This change will apply to all routes in the depot and cannot be undone`;
export const ARE_YOU_SURE_TO_RESET_AND_CONTINUE =
  "Are you sure you want to continue and reset all changes made to the route?";
export const RESULTS = "Results";
export const INFORMATION = "Information";

export const DRIVER_REQUEST_TABLE_TITLE = {
  REQUESTED_PARCELS: "Requested Parcels",
  REQUESTED_COLLECTIONS: "Requested Collections",
  NEW_STOP_RECIPIENT_ADDRESS: "New Stop - Recipient Address",
  NEW_STOP_RECIPIENT_ADDRESS_SUBTITLE:
    "If you click 'Accept' then the selected parcels will be moved to a new stop (shown below) for the Recipient's alternative address",
  NEW_STOP_GOODS_ON_HOLD: "New Stop - Goods on Hold",
  NEW_STOP_GOODS_ON_HOLD_SUBTITLE:
    "If you click 'Accept' then the selected parcels will be moved to the goods on hold (GOH) route as there is no alternative recipient address",
};

export const SELECT_DRIVER_ROUTE = "Select Driver/Route";
export const SELECT_DRIVER_ROUTE_TO = "Select Driver/Route To Transfer To";
export const LOCKED_BY = "Locked By:";

export const NO_STOPS_MATCH_CRITERIA = "No stops match the selected criteria";
export const NO_PARCELS_MATCH_CRITERIA =
  "No parcels match the selected criteria";
export const SELECT_BY_CRITERIA_TITLE = "SELECT BY";
export const CLEAR_ALL_CRITERIA = "Clear All Criteria";
export const APPLY_CRITERIA = "Apply Criteria";
export const OPEN_REQUESTS = "open requests";
export const IS_NOT_REQUIRED = "is not required";
export const IS_REQUIRED = "is required";
export const TIME_IS_REQUIRED = `Time ${IS_REQUIRED}`;
export const NEW_MERGE = "New Merge";
export const APPLY_MERGE = "Apply Merge";

export const OK = "Ok";
export const LOCKED = "Locked";
export const TRANSFER_STOP = "Transfer Stop";
export const MOVE_STOP = "Move Stop";
export const TRANSFER_PARCELS = "Transfer Parcels";
export const SELECTED_STOPS = "Selected Stops";
export const UNABLE_TRANSFER_TO_LOCKED_ROUTE =
  "Unable to transfer to a locked route";
export const TRANSFER_HIGH_VALUE_PARCEL =
  "You are transferring a High Value parcel. This route movement will be recorded against your user profile.";

export const MERGE_TO = "Merge To";
export const SHOW_MATCHING_POSTCODES = "Show Matching Postcodes";
export const RESULT = "Result";
export const NO_VALID_STOPS_AVAILABLE = "No valid stops available";

export const NEW_SPLIT = "New Split";
export const APPLY_SPLIT = "Apply Split";
export const SELECTED_PARCELS = "Selected Parcel(S)";
export const SPLIT_TO = "Split To";
export const SPLIT_INTO = "Split Into";
export const NEW_STOP = "New Stop";
export const EXISTING_STOP = "An Existing Stop";

export const IN_BUILD_CONTINUE_WARNING =
  "If you continue, the system will no longer automatically add stops to this route";
export const WARNING = "Warning";
export const CONTINUE = "Continue";
export const DOWNLOADED = "Downloaded";
export const IN_BUILD = "In Build";
export const LOADING = "Loading";
export const DEPARTED = "Departed";
export const ALL = "All";
export const OPPORTUNITY = "Opportunity";

export const TEN_THIRTY = "10:30";
export const TWELVE = "12:00";
export const EVENING = "Evening";
export const DEFAULT = "Default";
export const REQUESTS = "Requests";
export const ON_SCHEDULE = "On Schedule";
export const BEHIND_SCHEDULE = "Behind Schedule";
export const SCAN_TIME_EXCEEDED = "Scan Time Exceeded";

export const ROUTE_NUMBER = "Route Number";
export const DRIVER = "Driver";
export const SECTION = "Section";
export const CREATE_ROUTE = "Create Route";
export const NEXT = "Next";
export const ADD_NEW_ROUTE = "ADD NEW ROUTE";
export const INVALID_ROUTE_NUMBER = "Invalid route number";
export const SELECT_DRIVER = "Select Driver";

export const ARE_YOU_SURE = "Are You Sure?";
export const THIS_ROUT_IS_PLANNED = "This Route Is Planned For A Later Wave";
export const ROUTE_IS_DEFAULT_ROUTE = "Route is a default route";
export const NEED_CREATE_ROUTE_MANUALLY =
  "By Ticking This Box You Are Confirming That You Are In A DR Situation And Need To Create This Route Manually";

export const DRIVER_DETAILS = "DRIVER DETAILS";

export const defaultRoutesShortcuts = {
  NCD: "NCD",
  UNK: "UNK",
  TBB: "TBB",
  CFD: "CFD",
  FRA: "FRA",
  GOH: "GOH",
  UNASS: "000",
};

export const defaultRoutesNames = {
  NO_CAD_SCAN: "No CAD Scan",
  UNKNOWN: "Unknown",
  TO_BE_BOOKED_IN: "To be booked in",
  COLLECT_FROM_DEPOT: "Collect From Depot",
  FRAUD: "Fraud",
  GOODS_ON_HOLD: "Goods On Hold",
  UNASSIGNED: "Unassigned",
};

export const LOCK = "Lock";
export const UNLOCK = "Unlock";

export const THERE_WAS_AN_ERROR = "There Was An Error";
export const SOMETHING_WENT_WRONG =
  "Something went wrong while trying to display this web page.";
export const RELOAD_PAGE = "Reload Page";

export const DEPOT_OPERATIONS = "Depot Operations";
export const CENTRAL_SERVICES = "Central Services";
export const ODF = "ODF";
export const DEPOT_PLANNING = "Depot Planning";
export const SAVE_CHANGES = "Save Changes";

export const NO_AVAILABLE_DEPOTS = "No available depots";

export const MAIN_DRIVERS = "Main Drivers";
export const OTHER_DRIVERS = "Other Drivers";

export const SHIFT_MANEGERS = "Shift Managers";
export const OTHER_MANEGERS = "Other Managers";

export const PARCEL_SEARCH = "Parcel Search";
export const ROUTE_SEARCH = "Search Routes...";
export const DISASTER_RECOVERY = "Disaster Recovery";
export const DELAY_WAVE_CUT_OFF_TIMES = "Delay Wave Cut Off Times By";
export const DELAY_DEPART_TIMES = "Delay Depart Times By";
export const INVALID_SHORT_TIME_FORMAT = "Invalid time format (HH:mm)";
export const MAX_TIME_EXCEED_12_HOURS = "Time cannot exceed 12 hours";
export const SEARCH = "Search";
export const RESET = "Reset";
export const FINISHED = "Finished";
export const DEPOT_NUMBER = "Depot Number";
export const ROUTE = "Route";
export const NO_PARCELS_FOUND = "Not Found For Todays Routes";
export const SHORT_PARCEL_NUMBER = "Parcel Number Should Be At Least 9 Symbols";

export const BREAK_STOP_FAILED_MESSAGE =
  "Lunch Break can not be the first stop on route. Plase reposition the Lunch Break stop and try again";
export const UNABLE_TO_UNLOCK_ROUTE =
  "Unable to unlock route, please try again";

export const SCAN_TIME_ENTITIES = {
  TOTAL_SCAN_TIME: "Total Scan Time",
  TIME_DOWNLOADED: "Time Downloaded",
  TIME_FIRST_SCAN: "Time First Scan",
  TIME_AUTHORISED: "Time Authorised",
  TARGET_DEPART_TIME: "Target Depart Time",
  LOAD_RATE: "Load Rate",
};

export const DRIVER_FORM_ENTITIES = {
  DUTY_START: "Duty Start",
  DUTY_END: "Duty End",
  DEPART: "Depart",
  RETURN: "Return",
  DELIVERY_STOP: "Delivery Stop",
  COLLECTION_STOP: "Collection Stop",
  DRIVER_NAME: "A driver's name",
  VEHICLE_TYPE: "A vehicle type",
  SECTION: "A section",
};
export const AVAILABLE_ROUTES = "Available Routes";
export const SELECT_PLACEHOLDER = "Please select";
export const NOT_APPLICABLE = "N/A";
export const ROUTE_WITHOUT_DELIVERY_STOPS =
  "Route contains no delivery or collections stops.";

export const DEPOT_SUMMARY = "Depot Summary";
export const SECTION_SUMMARY = "Section Summary";

export const NO_DRIVER_ASSIGNED = "No Driver Assigned";
export const SCHEDULE_REQUIRED = "Schedule/Optimise Required";

export const NO_OPTIONS = "No Options";

export const OVERVIEW = "Overview";

export const SUCCESSFUL_TRANSFER_MESSAGE_$ =
  "You have successfully {0} the following stops to route ";

export const SUMMARY_$ = "{0} Summary";

export const SCHEDULE_WARNING_MESSAGE =
  "Please don’t forget to schedule or optimise";

export const SAVE_WARNING_MESSAGE = "Press 'save' to keep these changes.";

export const ROUTE_STATUS_WARNING = `${WARNING}: Route Status`;
export const ROUTE_STATUS_WARNING_MESSAGE =
  "Changing the route to Open once it has been downloaded could cause issues with Saturn.\n\nIf you wish to proceed, please make sure the route has been voided on Saturn first. Would you like to continue?";
